package com.karyadina.util

import kotlin.js.Date

/**
 * JavaScript implementation using Date.now()
 */
actual fun currentTimeMillis(): Long = Date.now().toLong()
